import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import './ConflictDetails.scss'

export default class ConflictDetails extends PureComponent {
  static propTypes = {
    conflicts: PropTypes.array
  }

  render() {
    if (!this.props.conflicts) {
      return null
    }

    return (
      <div className="conflict-details-wrapper detail-view-section">
        <ul className="conflict-list-items">
          {this.props.conflicts.map((conflict, index) => {
            return (
              <li key={index} className="conflict-list-item">
                <i className="fas fa-exclamation-triangle"></i>
                <span className="category">{conflict.category}</span>
                {conflict.description}
              </li>
            )
          })}
        </ul>
      </div>
    )
  }
}
